import { NovaEditor } from '@emerald-works-nova/editor'
import { Box } from '@mui/material'
import React, { useCallback } from 'react'
import { usePromiseEvent } from '../../../../../../hooks'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../../reducers'

const DraftJSPageBlock = ({ block, onChange }) => {
  const searchContent = usePromiseEvent('catalogSearch')
  const deleteTranscript = usePromiseEvent('contentDeleteTranscript')
  const deleteImage = usePromiseEvent('contentDeleteImage')
  const canEdit = useSelector(SkillBiteEditSlice.selectors.selectEditMode)

  const handleSearchContent = (search) => {
    return searchContent({
      size: 10,
      filters: {
        search
      }
    })
  }

  const onDeleteTranscript = useCallback(async (transcriptKey) => {
    await deleteTranscript({ s3Key: transcriptKey })
  }, [deleteTranscript])

  const onDeleteImage = useCallback(async (imageKey) => {
    await deleteImage({ s3Key: imageKey })
  }, [deleteImage])

  return (
    <Box>
      <NovaEditor
        key={block.id}
        hideInlineToolbar
        endUserView={!canEdit}
        scrollableContainer={document.getElementById('sb-page-container')}
        handleSearchContent={handleSearchContent}
        onDeleteTranscript={onDeleteTranscript}
        onDeleteImage={onDeleteImage}
        overrideStyles={{
          sideButtonLeftOffset: 32
        }}
        hostContext='skill-bite'
        body={{ data: block.data }}
        onChange={({ data }) => {
          onChange(data)
        }}
      />
    </Box>
  )
}

export default DraftJSPageBlock
